import { IBrickInstanceTargetingAction } from '../../../../../utility/IBrickInstanceTargetingAction';

export class OpenCallForwardDialog implements IBrickInstanceTargetingAction {
   public static readonly type = '[SkillBrowserBehaviour] Open call forward dialog';

   constructor(public brickInstanceId: string, public skillId: number) {}
}

export class CloseCallForwardDialog implements IBrickInstanceTargetingAction {
   public static readonly type = '[SkillBrowserBehaviour] Close call forward dialog';

   constructor(public brickInstanceId: string) {}
}

export class SkillBrowserEntrySelected implements IBrickInstanceTargetingAction {
   public static readonly type = '[SkillBrowserBehaviour] skill browser entry selected';

   constructor(public brickInstanceId: string, public skillId: number) {}
}

export class SkillBrowserSelectNextEntry implements IBrickInstanceTargetingAction {
   public static readonly type = '[SkillBrowserBehaviour] Select next entry ';

   constructor(public brickInstanceId: string, public direction: 'up' | 'down', public step = 1) {}
}
